import axios from 'axios';
import {
    VOUCHER_VALIDATE_REQUEST,
    VOUCHER_VALIDATE_SUCCESS,
    VOUCHER_VALIDATE_FAIL,
    VOUCHER_VALIDATE_RESET,
    VOUCHER_REMOVE
} from '../constants/voucherConstants';
import { detectMarket } from '../utils/market';

export const validateVoucher = (code, orderTotal, shippingTotal = 0) => async (dispatch, getState) => {
    try {
        dispatch({ type: VOUCHER_VALIDATE_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        // Build headers - include auth token only if user is logged in
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        if (userInfo && userInfo.token) {
            config.headers.Authorization = `Bearer ${userInfo.token}`;
        }

        const { data } = await axios.post(
            `/api/vouchers/validate/?market=${encodeURIComponent(detectMarket())}`,
            { code, order_total: orderTotal, shipping_total: shippingTotal },
            config
        );

        dispatch({
            type: VOUCHER_VALIDATE_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: VOUCHER_VALIDATE_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

export const removeVoucher = () => (dispatch) => {
    dispatch({ type: VOUCHER_REMOVE });
};

export const resetVoucher = () => (dispatch) => {
    dispatch({ type: VOUCHER_VALIDATE_RESET });
};
